export default __webpack_public_path__ + "static/media/content-3.37003f2a.jpg";